<template>
  <div class="item-box">
    <div class="item-col image">
      <div class="item-poster" v-if="item.beer">
        <a :title="item.beer.description" @click="onItemClick($t('route.beer'), item.beer)">
          <img :src="item.beer.beer_image ? item.beer.beer_image.path : '/static/beer-placeholder.jpg'" />
        </a>
        <el-button  v-if="($mq.resize && $mq.below('768px'))" class="orange-button mini" @click="onRemoveClick(item)">
          <i class="fa fa-trash">
          </i>
        </el-button>
      </div>
    </div>
    <div class="item-col details">
      <div class="item-wrapper">
        <a :title="item.beer.description" @click="onItemClick($t('route.beer'), item.beer)">
          <span class="title">{{ item.beer.description }}</span>
        </a>
        <span class="text">Brewery: {{ item.beer.description2 }}</span>
        <span class="text">Warehouse: {{ item.beer.stocks.branchName }}</span>
        <span class="text">{{ $t('currency.malaysia') }} {{ item.beer.user_price }}</span>
        <span class="pricetag">{{ $t('currency.malaysia') }} {{ totalprice }}</span>
        <el-form :label-position="labelPosition" :label-width="($mq.resize && $mq.below('950px')) ? '0px' : '135px'">
          <el-form-item :label="($mq.resize && $mq.below('950px')) ? '' : 'Order Quantity'">
            <!-- <el-input-number @change="onQuantityChange(item)" v-model="item.quantity" size="small" :step="step" :min="min" :max="item.beer.balsqty"></el-input-number> -->
            <number-input :width="150" @change="onQtyChange(item)" :quantity.sync="item.quantity" :step="step" :min="item.beer.stocks.qty > item.beer.minqty ? item.beer.minqty : item.beer.stocks.qty" :max="item.beer.stocks.qty" />
          </el-form-item>
        </el-form>
        <el-button v-if="!($mq.resize && $mq.below('768px'))" class="orange-button" @click="onRemoveClick(item)">
          <i class="fa fa-trash">
          </i>
          {{ $t('button.remove') }}
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import NumberInput from '@/components/NumberInput'
export default {
  props: {
    item: {
      type: Object,
      default: undefined
    }
  },
  components: {
    NumberInput
  },
  data () {
    return {
      labelPosition: 'left',
      step: 1,
      temp: 0,
      totalprice: 0
      // count: 1,
      // squantity: 6,
      // min: 0
    }
  },
  created () {
  },
  mounted () {
    this.totalprice = this.roundUp(this.item.beer.user_price * this.item.quantity)
    this.item.beer.totalprice = this.totalprice
    // this.squantity = this.item.quantity
    // this.count = Math.ceil(this.squantity / this.item.beer.minqty)
    // this.min = this.item.beer.balsqty > this.item.beer.minqty ? this.item.beer.minqty : this.item.beer.balsqty
  },
  computed: {
    getQuantity () {
      return this.item.quantity
    }
  },
  watch: {
    getQuantity () {
      this.totalprice = this.roundUp(this.item.beer.user_price * this.item.quantity)
      this.item.beer.totalprice = this.totalprice
      this.$emit('priceChange', this.item)
    }
  },
  methods: {
    roundUp (value) {
      return (Math.round(value * 100) / 100).toFixed(2)
    },
    onRemoveClick (data) {
      this.$store.dispatch('RemoveBeer', data).then(() => {
        this.$ls.set('beers', JSON.stringify(this.$store.getters.cartbeers))
        this.$emit('cartupdate')
      }).catch(err => {
        console.log(err)
      })
    },
    onQtyChange (item) {
      this.$store.dispatch('UpdateBeer', item).then(() => {
        this.$ls.set('beers', JSON.stringify(this.$store.getters.cartbeers))
        this.$emit('cartupdate')
      }).catch(err => {
        console.log(err)
      })
    },
    onItemClick (routeName, query) {
      const obj = query
      this.$router.push({ path: `/beer`, query: { id: obj.id, name: obj.description, breweryId: obj.taps_brewery_id, styleId: obj.taps_style_id } })
    }
    // onQuantityChange (item) {
    //   if (item.quantity > this.squantity) {
    //     this.count++
    //   } else {
    //     this.count--
    //   }
    //   let quantity = this.count * item.beer.minqty
    //   if (quantity > item.beer.balsqty) {
    //     quantity = item.beer.balsqty
    //   }
    //   item.quantity = quantity
    //   this.squantity = quantity
    //
    //   this.$store.dispatch('UpdateBeer', item).then(() => {
    //     this.$ls.set('beers', JSON.stringify(this.$store.getters.cartbeers))
    //     this.$emit('cartupdate')
    //   }).catch(err => {
    //     console.log(err)
    //   })
    //   // let limit = item.beer.balsqty
    //   // let current = item.quantity
    //   // let left = limit - current
    //   // if (left % this.min !== 0) {
    //   //   // console.log(1)
    //   //   this.step = left % this.min
    //   // } else if ((limit - current === this.min) && current % this.min !== 0) {
    //   //   // console.log(2)
    //   //   item.quantity += this.min - current % this.min
    //   //   this.step = current % this.min
    //   // } else {
    //   //   // console.log(3)
    //   //   this.step = this.min
    //   // }
    // }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/settings.scss";

.item-box {
  padding-bottom: 25px;
  & > .item-col {
    &.image {
      width: 100px;
      @media (min-width: 768px) {
        width: 150px;
      }
    }
    &.details {
      width: calc(100% - 100px);
      @media (min-width: 768px) {
        width: calc(100% - 150px);
      }
    }
    .item-poster {
      padding-right: 15px;
      @media (min-width: 768px) {
        padding-right: 25px;
      }
      a {
        cursor: pointer;
        & >img {
          border: 1px solid $gray-color;
          border-radius: 4px;
          width: 100%;
        }
      }
    }
    .orange-button {
      letter-spacing: 1px;
      &.mini {
        width: 100%;
        padding: 7px;
        max-width: 100%;
      }
    }
    .item-wrapper {
      a {
        cursor: pointer;
        display: inherit;
        & > .title {
          display: inherit;
          width: 100%;
          font-weight: bold;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      & > .title, & > .text {
        font-size: 16px;
      }
      & > .pricetag {
        color: $black-color;
        font-weight: bold;
        font-size: 18px;
        padding-bottom: 25px;
        @media (min-width: 768px) {
          font-size: 22px;
        }
      }
      & > span {
        display: block;
        padding-bottom: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cart/ItemList.vue